export default __webpack_public_path__ + "static/media/Airen HORZ.25c78975.png";